var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "料架唯一编号" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.queryCondition.mateCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "mateCode",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.mateCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  model: {
                                    value: _vm.queryCondition.status,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryCondition,
                                        "status",
                                        $$v
                                      )
                                    },
                                    expression: "queryCondition.status",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: { label: "1", value: "1" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "料架类型编号" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  model: {
                                    value: _vm.queryCondition.materialNo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryCondition,
                                        "materialNo",
                                        $$v
                                      )
                                    },
                                    expression: "queryCondition.materialNo",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: { label: "是", value: "是" },
                                  }),
                                  _c("el-option", {
                                    key: "0",
                                    attrs: { label: "否", value: "否" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "料架类型名称" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  model: {
                                    value: _vm.queryCondition.materialName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryCondition,
                                        "materialName",
                                        $$v
                                      )
                                    },
                                    expression: "queryCondition.materialName",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: { label: "是", value: "是" },
                                  }),
                                  _c("el-option", {
                                    key: "0",
                                    attrs: { label: "否", value: "否" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-row", { staticClass: "query-btn-row" }),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建日期" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "handle-input",
                                attrs: {
                                  type: "daterange",
                                  "range-separator": _vm.$t("common.to"),
                                  "start-placeholder":
                                    _vm.$t("common.startDate"),
                                  "end-placeholder": _vm.$t("common.endDate"),
                                },
                                model: {
                                  value: _vm.queryCondition.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "date", $$v)
                                  },
                                  expression: "queryCondition.date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.queryData },
                            },
                            [_vm._v("搜索")]
                          ),
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.apply } },
                [_vm._v("料架唯一编号申请")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "mateCode", label: "料架唯一编码" },
              }),
              _c("el-table-column", {
                attrs: { prop: "no", label: "料架类型编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "mateName", label: "料架类型名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "createDate", label: "创建日期" },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: { layout: "prev, pager, next", total: _vm.total },
                on: { "current-change": _vm.handleCurrentChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "料架唯一编号申请", visible: _vm.applyDialog },
          on: {
            "update:visible": function ($event) {
              _vm.applyDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.applyForm,
                "label-position": _vm.labelPosition,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "料架类型编号" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.applyForm.mateCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.applyForm, "mateCode", $$v)
                      },
                      expression: "applyForm.mateCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "料架类型名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.applyForm.mateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.applyForm, "mateName", $$v)
                      },
                      expression: "applyForm.mateName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "申请数量" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.applyForm.applyCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.applyForm, "applyCount", $$v)
                      },
                      expression: "applyForm.applyCount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.applyDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.applyMateCode },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }